import VariationFinishPage from './VariationFinishPage'

export default VariationFinishPage
